module.exports = __webpack_public_path__ + "img/yacht.77dde1ba.png";